// extracted by mini-css-extract-plugin
export var container = "RarityBreakdown-module--container--40140";
export var heading = "RarityBreakdown-module--heading--524a9";
export var labelTable = "RarityBreakdown-module--labelTable--5618f";
export var table = "RarityBreakdown-module--table--293f3";